import { Banner, Button, Typography } from "@hellocarbo/lasagne";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const COOKIE_NAME = "feedback_banner_closed";
const COOKIE_EXPIRY_DAYS = 30;

function ReviewBanner({ linkUrl }: { linkUrl: string }) {
  const { t } = useTranslation(["review"]);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (Cookies.get(COOKIE_NAME)) {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    Cookies.set(COOKIE_NAME, "true", { expires: COOKIE_EXPIRY_DAYS });
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Banner
      dismissable
      className="gap-x-xs mt-sm ml-md w-auto max-w-[90%]"
      onDismiss={handleDismiss}
    >
      <Typography step="-1" weight="bold" as="p">
        {t("review:banner.private.text")}
      </Typography>
      <Button
        shape="soft"
        intent="secondary"
        size="small"
        as={Link}
        to={linkUrl}
      >
        {t("review:banner.private.giveMyOpinion")}
      </Button>
    </Banner>
  );
}

export default ReviewBanner;
